// Sorting options for staffs
const sortOptions = [
   { value: "recent", label: "Latest Staffs" },
  { value: "oldest", label: "Oldest Staffs" },
 
  
];

module.exports = { sortOptions };
